export default __webpack_public_path__ + "static/media/Banners_diademuertos_cochemoto_330x330.8c599a74.jpg";